import { createAssistantClient } from "@thekrystalship/krystal-chat/lib/assistantClient";
import { assistantSession } from "./assistantSession.js";

// assistantClient.js — the seam onto the assistant, spoken directly.
//
// The chat addresses the assistant at the base the build names (`/assistant` on the panel's own origin,
// which the panel's vhost proxies to the plugin) with the panel's own session token, which the assistant
// verifies itself. The wire is the assistant wire contract (`tks-assistant/docs/wire-contract.md`),
// served by the assistant's plugin of the harness, and the client of it is the design system's
// `createAssistantClient`: turns picked up again after a dropped connection, the event stream's
// positions, renewal around the calls that may and may not be sent twice, the lists as arrays, and
// attachments. This module is what is KGSM's about it: where the assistant is, and which session it is
// spoken to with.
//
// A panel built with no assistant has no chat: `routeError` is thrown rather than a call guessed at the
// panel's own origin.
//
// The client is given the cluster session (`assistantSession.fresh`) and asks it for a bearer on every
// call, renewed on a refusal; nothing else in `src/` reads one.

function routeError() {
  const e = new Error("This panel has no assistant.");
  e.code = "ENOROUTE";
  e.userMessage = "This panel is not set up with an assistant.";
  return e;
}

function baseOf() {
  const base = assistantSession.baseOf();
  if (!base) throw routeError();
  return base;
}

// One client, so what it remembers — its event stream's position — outlives the calls that ask for it,
// and the chat is handed the same object on every render.
let kgsm = null;

function client() {
  if (kgsm) return kgsm;

  const base = createAssistantClient({
    baseUrl: baseOf,
    session: assistantSession,
  });

  kgsm = {
    ...base,
    hasRoute: () => assistantSession.hasRoute(),
  };
  return kgsm;
}

const assistant = { client };

export { assistant };
